import React from 'react';
import moment from 'moment';
import { object, string, number, array } from 'yup';
import * as _ from 'lodash';
import SuccessPopUP from '../../UserKyc/UserKYCPopUP/SuccessPopUp';
import LAPTypeSelection from './LAPComponents/LAPTypeSelection/LAPTypeSelection';
import LAPPurpose from './LAPComponents/LAPPurpose/LAPPurpose';
import AddressProof from '../../Income/SENP/BusinessAddressProof';
import * as Yup from 'yup';
import Documents from './../../Income/SENP/SENPDocuments';
import AddSalary from './../../Income/IncomeDetailsComponent/SalaryDetails/AddSalary';
import AddLoan from '../../Income/LoanDetails/AddLoan';
import ITR from '../../Income/SENP/IncomeFiles/ITR';
import getGST from '../../Income/SENP/getGst';
import { navigate } from 'gatsby';
let viewAccount = false;

export const isViewAccount = () => {
  return viewAccount;
};

let allValues = {};
export const getAllValues = () => allValues;

const Steps = [
  {
    id: 'getGST',
    component: getGST,
    initialValues: {
      preValues: getAllValues,
      gst_number: 'yes',
      gst_value: '',
      file: [],
      imgUrl: []
    },
    validationSchema: Yup.object().shape({
      gst_value: Yup.string()
        .when('gst_number', {
          is: 'yes',
          then: Yup.string()
            .required('required')
            .matches(
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
              'Invalid GST No.'
            )
        })
        .nullable()
    }),
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'addProof',
    component: AddressProof,
    initialValues: {
      add_proof: { value: '', label: 'Select Business Address Proof' },
      UploadRent: 0,
      file: [],
      imgUrl: [],
      preValues: getAllValues,
      utilityBIll: { value: '', label: 'Select Utility Bill' }
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'docsLists',
    component: Documents,
    initialValues: {
      file: [],
      imgUrl: [],
      preValues: getAllValues,
      neededDocs: [],
      allValues: '',
      step: 'LAP'
    },
    validate: values => {
      let error = {};
      if (
        !_.get(values, 'file.0.0', false) &&
        !values.moaFile &&
        !_.get(values, 'file.1.0', false) &&
        !values.aoaFile &&
        !_.get(values, 'file.3.0', false) &&
        !values.shareHolders &&
        !_.get(values, 'file.4.0', false) &&
        !values.regCertificate
      ) {
        error['error'] = 'true';
      }

      return error;
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'itr',
    component: ITR,
    initialValues: {
      file: [],
      imgUrl: [],
      pincode: '',
      statementType: 'individual'
    },
    validate: values => {
      const error = {};
      if (!values.preValues) {
        if (!values.file[0] && !values.file[1] && !values.file[2]) {
          error['error'] = true;
        }
        return error;
      }
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'AddSalary',
    component: AddSalary,
    initialValues: {
      professionType: '',
      file: [],
      imgUrl: [],
      accountNo: '',
      ifscCode: '',
      statementType: '',
      viewAccount: isViewAccount,
      addNewAccount: true,
      preValues: getAllValues,
      accountType: 'current'
    },
    validationSchema: Yup.object().shape({
      accountNo: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string()
          .required('Required')
          .min(9, 'Account Number Must be minimum 9 digits')
          .max(18, 'Account Number should not excced 18 digits')
      }),
      ifscCode: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string()
          .required('Required')
          .matches(/^([A-Z|a-z]{4}[0][\d]{6})?$/, 'Invalid IFSC code Format')
      }),

      statementType: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string().required('Required')
      })
    }),

    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'AddLoan',
    component: AddLoan,
    initialValues: {
      file: [],
      imgUrl: [],
      lender: '',
      loanType: '',
      sanctionAmount: '',
      balanceAmount: '',
      totalTenure: '',
      balanceTenure: '',
      sanctionDocId: null,
      statementDocId: null,
      viewAccount: isViewAccount,
      addNewLoan: true
    },
    validationSchema: Yup.object().shape({
      lender: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      loanType: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      sanctionAmount: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      balanceAmount: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      totalTenure: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      currentEmi: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      balanceTenure: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      })
    }),
    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'incomeFinal',
    component: () => {
      navigate('/app/LAP/property');
      return <></>;
    }
  }
];
export default Steps;
